import React from 'react';
import Pricing from '../components/pricing';

const PricingPage = () => {
  return (
    <>
      <Pricing />
    </>
  );
};

export default PricingPage;